import React from "react";
import { SxStyleProp } from "theme-ui";
import Flex, { Props as FlexProps } from "../Flex/Flex";

interface Props
  extends React.LabelHTMLAttributes<HTMLLabelElement & HTMLDivElement> {
  sx?: SxStyleProp;
}

const Label: React.FunctionComponent<Props & FlexProps> = React.forwardRef(
  ({ sx, ...restProps }, ref) => (
    <Flex
      ref={ref}
      as="label"
      variant="label"
      sx={{
        width: "100%",
        fontSize: 1,
        color: "muted",

        ...(sx as any),
      }}
      {...restProps}
    />
  ),
);

Label.displayName = "Label";

export default Label;
